<template>
  <div class="tax-table-wrap" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>增值税及附加税费申报表<br />（一般纳税人适用）</dt>
      <dd>根据国家税收法律法规及增值税相关规定制定本表。纳税人不论有无销售额，均应按税务机关核定的纳税期限填写本表，并向当地税务机关申报。</dd>
      <dd>
        <div>税款所属期：{{ staticConfig.taxStartTime }} ~ {{ staticConfig.taxEndTime }}</div>

        <div>填报日期：{{ staticConfig.fillFormDate }}</div>

        <div>单位：元至角分</div>
      </dd>
    </dl>

    <div class="tax-table-body">
      <table>
        <tbody class="read-mode">
          <tr>
            <td colspan="2">纳税人识别号（统一社会信用代码）</td>
            <td colspan="3">{{ staticConfig.creditCode }}</td>
            <td colspan="2">所属行业</td>
            <td colspan="2"></td>
          </tr>
          <tr>
            <td colspan="2">纳税人名称（公章）</td>
            <td width="210px">{{ staticConfig.companyName }}（一般纳税人）</td>
            <td width="100px">法定人代表姓名</td>
            <td width="60px">刘梅</td>
            <td width="80px">注册地址</td>
            <td>{{ staticConfig.registerAdd }}</td>
            <td width="130px">生产经营地址</td>
            <td colspan="1" width="130px">{{ staticConfig.productAdd }}</td>
          </tr>
          <tr>
            <td colspan="2">开户银行及账号</td>
            <td colspan="2" width="200px">
              {{ staticConfig.openBankName }} <br />
              {{ staticConfig.openBankAccount }}
            </td>
            <td colspan="2">登记注册类型</td>
            <td colspan="1">有限责任公司</td>
            <td>电话号码</td>
            <td>{{ staticConfig.telephoneNumber }}</td>
          </tr>
          <tr>
            <td rowspan="2" colspan="3"><p class="td_first td_align td_height font-w">项目</p></td>
            <td rowspan="2"><p class="td_align font-w">栏次</p></td>
            <td colspan="3" width="250px"><p class="td_first td_align td_height ts font-w">一般项目</p></td>
            <td colspan="2" width="160px"><p class="td_first td_align ts font-w">即征即退项目</p></td>
          </tr>
          <tr>
            <td colspan="2" width="140px"><p class="td_first td_align td_height font-w">本月数</p></td>
            <td width="140px"><p class="td_first td_align ts font-w">本年累计</p></td>
            <td width="140px" colspan="1"><p class="td_first td_align font-w" style="width: 100px">本月数</p></td>
            <td width="140px"><p class="td_first td_align ts font-w">本年累计</p></td>
          </tr>
          <tr>
            <td colspan="9" align="left" class="td1">销售额</td>
          </tr>
          <tr>
            <!-- <td rowspan="10" width="105px">销<br />售<br />额</td> -->
            <td colspan="3">(一)按适用税率计税销售额</td>
            <td>1</td>
            <td colspan="2">{{ parseFloatNum(data.v1x1.value) }}</td>
            <td>{{ parseFloatNum(data.v1x2.value) }}</td>
            <td colspan="1">{{ parseFloatNum(data.v1x3.value) }}</td>
            <td>{{ parseFloatNum(data.v1x4.value) }}</td>
          </tr>
          <tr>
            <td colspan="3">其中：应税货物销售额</td>
            <td>2</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v2x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v2x2.value) }}</td>
            <td colspan="1">
              <el-input-number v-model.trim="data.v2x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v2x4.value) }}</td>
          </tr>
          <tr>
            <td colspan="3">&nbsp;应税劳务销售额</td>
            <td>3</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v3x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v3x2.value) }}</td>
            <td colspan="1">
              <el-input-number v-model.trim="data.v3x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v3x4.value) }}</td>
          </tr>
          <tr>
            <td colspan="3">&nbsp;纳税检查调整的销售额</td>
            <td>4</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v4x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v4x2.value) }}</td>
            <td colspan="1">
              <el-input-number v-model.trim="data.v4x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v4x4.value) }}</td>
          </tr>
          <tr>
            <td colspan="3">(二)按简易办法计税销售额</td>
            <td>5</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v5x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v5x2.value) }}</td>
            <td colspan="1">
              <el-input-number v-model.trim="data.v5x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v5x4.value) }}</td>
          </tr>
          <tr>
            <td colspan="3">其中：纳税检查调整的销售额</td>
            <td>6</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v6x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v6x2.value) }}</td>
            <td colspan="1">
              <el-input-number v-model.trim="data.v6x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v6x4.value) }}</td>
          </tr>
          <tr>
            <td colspan="3">(三)免、抵、退办法出口销售额</td>
            <td>7</td>
            <td colspan="2">{{ parseFloatNum(data.v7x1.value) }}</td>
            <td>{{ parseFloatNum(data.v7x2.value) }}</td>
            <td colspan="1">---</td>
            <td>---</td>
          </tr>
          <tr>
            <td colspan="3">(四)免税销售额</td>
            <td>8</td>
            <td colspan="2">{{ parseFloatNum(data.v8x1.value) }}</td>
            <td>{{ parseFloatNum(data.v8x2.value) }}</td>
            <td colspan="1">---</td>
            <td>---</td>
          </tr>
          <tr>
            <td colspan="3">其中：免税货物销售额</td>
            <td>9</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v9x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v9x2.value) }}</td>
            <td colspan="1">---</td>
            <td>---</td>
          </tr>
          <tr>
            <td colspan="3">&nbsp;免税劳务销售额</td>
            <td>10</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v10x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v10x2.value) }}</td>
            <td colspan="1">---</td>
            <td>---</td>
          </tr>
          <tr>
            <td colspan="9" align="left" class="td1">税款计算</td>
          </tr>
          <tr>
            <td colspan="3">销项税额</td>
            <td>11</td>
            <td colspan="2">
              <!-- 自动关联附表二10税额 -->
              <!-- 考题 -->
              <taxQue :data="data.v11x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v11x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v11x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v11x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td>{{ parseFloatNum(data.v11x2.value) }}</td>
            <td colspan="1">{{ parseFloatNum(data.v11x3.value) }}</td>
            <td>{{ parseFloatNum(data.v11x4.value) }}</td>
          </tr>
          <tr>
            <td colspan="3">进项税额</td>
            <td>12</td>
            <td colspan="2">
              <!-- 自动关联附表二12税额 -->
              <!-- 考题 -->
              <taxQue :data="data.v12x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v12x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v12x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v12x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td>{{ parseFloatNum(data.v12x2.value) }}</td>
            <td colspan="1">{{ parseFloatNum(data.v12x3.value) }}</td>
            <td>{{ parseFloatNum(data.v12x4.value) }}</td>
          </tr>
          <tr>
            <td colspan="3">上期留抵税额</td>
            <td>13</td>
            <td colspan="2">{{ parseFloatNum(data.v13x1.value) }}</td>
            <td>{{ parseFloatNum(data.v13x2.value) }}</td>
            <td colspan="1">{{ parseFloatNum(data.v13x3.value) }}</td>
            <td>{{ parseFloatNum(data.v13x4.value) }}</td>
          </tr>
          <tr>
            <td colspan="3">进项税额转出</td>
            <td>14</td>
            <td colspan="2">
              {{ parseFloatNum(data.v14x1.value) }}
            </td>
            <td>{{ parseFloatNum(data.v14x2.value) }}</td>
            <td colspan="1">
              {{ parseFloatNum(data.v14x3.value) }}
            </td>
            <td>{{ parseFloatNum(data.v14x4.value) }}</td>
          </tr>
          <tr>
            <td colspan="3">免、抵、退应退税额</td>
            <td>15</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v15x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v15x2.value) }}</td>
            <td colspan="1">---</td>
            <td>---</td>
          </tr>
          <tr>
            <td colspan="3">按适用税率计算的纳税检查应补缴税额</td>
            <td>16</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v16x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v16x2.value) }}</td>
            <td colspan="1">---</td>
            <td>---</td>
          </tr>
          <tr>
            <td colspan="3">应抵扣税额合计</td>
            <td>17=12+13-14-15+16</td>
            <td colspan="2">{{ parseFloatNum(data.v17x1.value) }}</td>
            <td>---</td>
            <td colspan="1">{{ parseFloatNum(data.v17x3.value) }}</td>
            <td>---</td>
          </tr>
          <tr>
            <td colspan="3">实际抵扣税额</td>
            <td>18(如17&lt;11,则为17,否则为11)</td>
            <td colspan="2">{{ parseFloatNum(data.v18x1.value) }}</td>
            <td>{{ parseFloatNum(data.v18x2.value) }}</td>
            <td colspan="1">{{ parseFloatNum(data.v18x3.value) }}</td>
            <td>{{ parseFloatNum(data.v18x4.value) }}</td>
          </tr>
          <tr>
            <td colspan="3">应纳税额</td>
            <td>19=11-18</td>
            <td colspan="2">{{ parseFloatNum(data.v19x1.value) }}</td>
            <td>{{ parseFloatNum(data.v19x2.value) }}</td>
            <td colspan="1">{{ parseFloatNum(data.v19x3.value) }}</td>
            <td>{{ parseFloatNum(data.v19x4.value) }}</td>
          </tr>
          <tr>
            <td colspan="3">期末留抵税额</td>
            <td>20=17-18</td>
            <td colspan="2">{{ parseFloatNum(data.v20x1.value) }}</td>
            <td>{{ parseFloatNum(data.v20x2.value) }}</td>
            <td colspan="1">{{ parseFloatNum(data.v20x3.value) }}</td>
            <td>---</td>
          </tr>
          <tr>
            <td colspan="3">简易计税办法计算的应纳税额</td>
            <td>21</td>
            <td colspan="2">{{ parseFloatNum(data.v21x1.value) }}</td>
            <td>{{ parseFloatNum(data.v21x2.value) }}</td>
            <td colspan="1">{{ parseFloatNum(data.v21x3.value) }}</td>
            <td>{{ parseFloatNum(data.v21x4.value) }}</td>
          </tr>
          <tr>
            <td colspan="3">按简易计税办法计算的纳税检查应补缴税额</td>
            <td>22</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v22x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v22x2.value) }}</td>
            <td colspan="1">---</td>
            <td>---</td>
          </tr>
          <tr>
            <td colspan="3">应纳税额减征额</td>
            <td>23</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v23x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v23x2.value) }}</td>
            <td colspan="1">
              <el-input-number v-model.trim="data.v23x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v23x4.value) }}</td>
          </tr>
          <tr>
            <td colspan="3">应纳税额合计</td>
            <td>24=19+21-23</td>
            <td colspan="2">{{ parseFloatNum(data.v24x1.value) }}</td>
            <td>{{ parseFloatNum(data.v24x2.value) }}</td>
            <td colspan="1">{{ parseFloatNum(data.v24x3.value) }}</td>
            <td>{{ parseFloatNum(data.v24x4.value) }}</td>
          </tr>
          <tr>
            <td colspan="9" align="left" class="td1">税款缴纳</td>
          </tr>
          <tr>
            <td colspan="3">期初未缴税额（多缴为负数）</td>
            <td>25</td>
            <td colspan="2">
              <!-- 考题 -->
              <taxQue :data="data.v25x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v25x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v25x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v25x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td>{{ parseFloatNum(data.v25x2.value) }}</td>
            <td colspan="1">{{ parseFloatNum(data.v25x3.value) }}</td>
            <td>{{ parseFloatNum(data.v25x4.value) }}</td>
          </tr>
          <tr>
            <td colspan="3">实收出口开具专用缴款书退税额</td>
            <td>26</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v26x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v26x2.value) }}</td>
            <td colspan="1">---</td>
            <td>---</td>
          </tr>
          <tr>
            <td colspan="3">本期已缴税额</td>
            <td>27=28+29+30+31</td>
            <td colspan="2">{{ parseFloatNum(data.v27x1.value) }}</td>
            <td>{{ parseFloatNum(data.v27x2.value) }}</td>
            <td colspan="1">{{ parseFloatNum(data.v27x3.value) }}</td>
            <td>{{ parseFloatNum(data.v27x4.value) }}</td>
          </tr>
          <tr>
            <td colspan="3">①分次预缴税额</td>
            <td>28</td>
            <td colspan="2">{{ parseFloatNum(data.v28x1.value) }}</td>
            <td>---</td>
            <td colspan="1">{{ parseFloatNum(data.v28x3.value) }}</td>
            <td>---</td>
          </tr>
          <tr>
            <td colspan="3">②出口开具专用缴款书预缴税额</td>
            <td>29</td>
            <td colspan="2">{{ parseFloatNum(data.v29x1.value) }}</td>
            <td>---</td>
            <td colspan="1">{{ parseFloatNum(data.v29x3.value) }}</td>
            <td>---</td>
          </tr>
          <tr>
            <td colspan="3">③本期缴纳上期应纳税额</td>
            <td>30</td>
            <td colspan="2">
              <!-- 考题 -->
              <taxQue :data="data.v30x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v30x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v30x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v30x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td>{{ parseFloatNum(data.v30x2.value) }}</td>
            <td colspan="1">{{ parseFloatNum(data.v30x3.value) }}</td>
            <td>{{ parseFloatNum(data.v30x4.value) }}</td>
          </tr>
          <tr>
            <td colspan="3">④本期缴纳欠缴税额</td>
            <td>31</td>
            <td colspan="2">{{ parseFloatNum(data.v31x1.value) }}</td>
            <td>{{ parseFloatNum(data.v31x2.value) }}</td>
            <td colspan="1">{{ parseFloatNum(data.v31x3.value) }}</td>
            <td>{{ parseFloatNum(data.v31x4.value) }}</td>
          </tr>
          <tr>
            <td colspan="3">期末未缴税额（多缴为负数）</td>
            <td>32=24+25+26-27</td>
            <td colspan="2">{{ parseFloatNum(data.v32x1.value) }}</td>
            <td>{{ parseFloatNum(data.v32x2.value) }}</td>
            <td colspan="1">{{ parseFloatNum(data.v32x3.value) }}</td>
            <td>{{ parseFloatNum(data.v32x4.value) }}</td>
          </tr>
          <tr>
            <td colspan="3">其中：欠缴税额（≥0）</td>
            <td>33=25+26-27</td>
            <td colspan="2">{{ parseFloatNum(data.v33x1.value) }}</td>
            <td>---</td>
            <td colspan="1">{{ parseFloatNum(data.v33x3.value) }}</td>
            <td>---</td>
          </tr>
          <tr>
            <td colspan="3">本期应补(退)税额</td>
            <td>34=24-28-29</td>
            <td colspan="2">
              <!-- 考题 -->
              <taxQue :data="data.v34x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v34x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v34x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v34x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td>---</td>
            <td colspan="1">{{ parseFloatNum(data.v34x3.value) }}</td>
            <td>---</td>
          </tr>
          <tr>
            <td colspan="3">即征即退实际退税额</td>
            <td>35</td>
            <td colspan="2">---</td>
            <td>---</td>
            <td colspan="1">
              <el-input-number v-model.trim="data.v35x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v35x4.value) }}</td>
          </tr>
          <tr>
            <td colspan="3">期初未缴查补税额</td>
            <td>36</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v36x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v36x2.value) }}</td>
            <td colspan="1">---</td>
            <td>---</td>
          </tr>
          <tr>
            <td colspan="3">本期入库查补税额</td>
            <td>37</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v37x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v37x2.value) }}</td>
            <td colspan="1">---</td>
            <td>---</td>
          </tr>
          <tr>
            <td colspan="3">期末未缴查补税额</td>
            <td>38=16+22+36-37</td>
            <td colspan="2">{{ parseFloatNum(data.v38x1.value) }}</td>
            <td>{{ parseFloatNum(data.v38x2.value) }}</td>
            <td colspan="1">---</td>
            <td>---</td>
          </tr>
          <tr>
            <td colspan="9" align="left" class="td1">附加税费</td>
          </tr>
          <tr>
            <td colspan="3">城市维护建设税本期应补（退）税额</td>
            <td>39</td>
            <td colspan="2">{{ parseFloatNum(data.v39x1.value) }}</td>
            <td>{{ parseFloatNum(data.v39x2.value) }}</td>
            <td colspan="1">---</td>
            <td>---</td>
          </tr>
          <tr>
            <td colspan="3">教育费附加本期应补（退）费额</td>
            <td>40</td>
            <td colspan="2">{{ parseFloatNum(data.v40x1.value) }}</td>
            <td>{{ parseFloatNum(data.v40x2.value) }}</td>
            <td colspan="1">---</td>
            <td>---</td>
          </tr>
          <tr>
            <td colspan="3">地方教育附加本期应补（退）费额</td>
            <td>41</td>
            <td colspan="2">{{ parseFloatNum(data.v41x1.value) }}</td>
            <td>{{ parseFloatNum(data.v41x2.value) }}</td>
            <td colspan="1">---</td>
            <td>---</td>
          </tr>
          <tr>
            <td colspan="9">
              声明：此表是根据国家税收法律法规及相关规定填写的，本人（单位）对填报内容（及附带资料）的真实性、可靠性、完整性负责。
              <br />
              <p style="text-align: right">纳税人（签章）： 年 月 日</p>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              经办人：
              <br />
              经办人身份证号：
              <br />
              代理机构签章：
              <br />
              代理机构统一社会信用代码：
            </td>
            <td colspan="5">
              受理人：
              <br />
              受理税务机关（章）： 国家税务总局北京市
              <br />
              受理日期： 年 月 日
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../reportTaxStaticConfig.js";
import taxQue from "../../cmp/taxQue.vue";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};

function watchStart() {
  watch(
    data,
    (newVal, oldVal) => {
      try {
        // 16行第2列第4列计算
        for (let row = 1; row <= 41; row++) {
          // 不参与的行
          if (![17, 18, 19, 20, 24, 27, 32, 33, 34, 38].includes(row)) {
            data.value[`v${row}x2`].value = data.value[`v${row}x1`].value;
            data.value[`v${row}x4`].value = data.value[`v${row}x3`].value;
          }
        }
        // 4列若干行计算
        for (let column = 1; column <= 4; column++) {
          // 17=12+13-14-15+16
          data.value[`v17x${column}`].value = new Big(data.value[`v12x${column}`].value)
            .plus(data.value[`v13x${column}`].value)
            .minus(data.value[`v14x${column}`].value)
            .minus(data.value[`v15x${column}`].value)
            .plus(data.value[`v16x${column}`].value)
            .round(2)
            .toNumber();
          // 18(如17<11,则为17,否则为11)
          // if (![3, 4].includes(column)) { 畅捷通3,4列不参与 }
          data.value[`v18x${column}`].value = Math.min(data.value[`v17x${column}`].value, data.value[`v11x${column}`].value);
          // 19=11-18
          data.value[`v19x${column}`].value = new Big(data.value[`v11x${column}`].value).minus(data.value[`v18x${column}`].value).round(2).toNumber();
          // 20=17-18
          data.value[`v20x${column}`].value = new Big(data.value[`v17x${column}`].value).minus(data.value[`v18x${column}`].value).round(2).toNumber();
          // 24=19+21-23
          data.value[`v24x${column}`].value = new Big(data.value[`v19x${column}`].value).plus(data.value[`v21x${column}`].value).minus(data.value[`v23x${column}`].value).round(2).toNumber();
          // 27=28+29+30+31
          data.value[`v27x${column}`].value = new Big(data.value[`v28x${column}`].value)
            .plus(data.value[`v29x${column}`].value)
            .plus(data.value[`v30x${column}`].value)
            .plus(data.value[`v31x${column}`].value)
            .round(2)
            .toNumber();
          // 32=24+25+26-27
          data.value[`v32x${column}`].value = new Big(data.value[`v24x${column}`].value)
            .plus(data.value[`v25x${column}`].value)
            .plus(data.value[`v26x${column}`].value)
            .minus(data.value[`v27x${column}`].value)
            .round(2)
            .toNumber();
          // 33=25+26-27
          data.value[`v33x${column}`].value = new Big(data.value[`v25x${column}`].value).plus(data.value[`v26x${column}`].value).minus(data.value[`v27x${column}`].value).round(2).toNumber();
          // 34=24-28-29
          data.value[`v34x${column}`].value = new Big(data.value[`v24x${column}`].value).minus(data.value[`v28x${column}`].value).minus(data.value[`v29x${column}`].value).round(2).toNumber();
          // 38=16+22+36-37
          data.value[`v38x${column}`].value = new Big(data.value[`v16x${column}`].value)
            .plus(data.value[`v22x${column}`].value)
            .plus(data.value[`v36x${column}`].value)
            .minus(data.value[`v37x${column}`].value)
            .round(2)
            .toNumber();
        }
      } catch (e) {
        console.log(e);
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
}

// 小数点
function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss">
.td1 {
  font-size: 16px !important;
  font-weight: bold;
  background-color: #ffffff;
}
</style>

<script>
const tableHtml = `
<table>
  <tbody class="read-mode">
    <tr>
      <td colspan="2"><div class="td_height" style="padding-left: 4px">纳税人识别号（统一社会信用代码）</div></td>
      <td colspan="3"><span>91430108MA68AUED0W</span></td>
      <td colspan="2"><div class="td_height" style="padding-left: 4px">所属行业</div></td>
      <td colspan="2"><div class="cGridInput" style="margin-right: 5%"></div></td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height" style="padding-left: 4px">纳税人名称（公章）</div></td>
      <td width="210px">
        <div class="td_height cGridInput"><span id="BZDW_SPAN">培达商贸有限公司（一般纳税人）</span></div>
      </td>
      <td width="100px"><div class="td_height td_align">法定人代表姓名</div></td>
      <td width="60px"><div class="cGridInput" style="margin-right: 5%">刘梅</div></td>
      <td width="80px"><div class="td_height" style="padding-left: 3px">注册地址</div></td>
      <td><div class="td_height cGridInput" style="margin-right: 5%; width: 100px">郑州市金水区丰润中路 10 号院 7 号楼</div></td>
      <td width="130px"><div class="td_height td_align">生产经营地址</div></td>
      <td colspan="1" width="130px"><div class="td_height cGridInput" style="margin-right: 5%; width: 135px">郑州市金水区丰润中路 10 号院 7 号楼</div></td>
    </tr>
    <tr>
      <td colspan="2"><div style="padding-left: 3px">开户银行及账号</div></td>
      <td colspan="2" width="200px"><div class="td_height cGridInput" style="margin-right: 5%">中国工商银行股份有限公司郑州金水支行0200347809000001478</div></td>
      <td colspan="2"><div class="td_height" style="padding-left: 11px">登记注册类型</div></td>
      <td colspan="1"><div class="td_height cGridInput" style="margin-right: 5%">有限责任公司</div></td>
      <td><div style="padding-left: 3px">电话号码</div></td>
      <td><div class="td_height cGridInput" style="margin-right: 5%">0371—68952489</div></td>
    </tr>
    <tr>
      <td rowspan="2" colspan="3"><p class="td_first td_align td_height font-w">项目</p></td>
      <td rowspan="2"><p class="td_align font-w">栏次</p></td>
      <td colspan="3" width="250px"><p class="td_first td_align td_height ts font-w">一般项目</p></td>
      <td colspan="2" width="160px"><p class="td_first td_align ts font-w">即征即退项目</p></td>
    </tr>
    <tr>
      <td colspan="2" width="140px"><p class="td_first td_align td_height font-w">本月数</p></td>
      <td width="140px"><p class="td_first td_align ts font-w">本年累计</p></td>
      <td width="140px" colspan="1"><p class="td_first td_align font-w" style="width: 100px">本月数</p></td>
      <td width="140px"><p class="td_first td_align ts font-w">本年累计</p></td>
    </tr>
    <tr>
      <td rowspan="10" width="105px">
        <div class="td_align">销<br />售<br />额</div>
      </td>
      <td colspan="2"><div class="td_height" style="width: 210px">(一)按适用税率计税销售额</div></td>
      <td><div class="td_height td_align">1</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height indent_2em">其中：应税货物销售额</div></td>
      <td><div class="td_height td_align">2</div></td>
      <td colspan="2">
        <div validate="data_2_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1">
        <div validate="data_2_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height indent_4em">&nbsp;应税劳务销售额</div></td>
      <td><div class="td_height td_align">3</div></td>
      <td colspan="2">
        <div validate="data_3_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1">
        <div validate="data_3_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height indent_4em">&nbsp;纳税检查调整的销售额</div></td>
      <td><div class="td_height td_align">4</div></td>
      <td colspan="2">
        <div validate="data_4_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1">
        <div validate="data_4_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">(二)按简易办法计税销售额</div></td>
      <td><div class="td_height td_align">5</div></td>
      <td colspan="2">
        <div validate="data_5_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1">
        <div validate="data_5_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">其中：纳税检查调整的销售额</div></td>
      <td><div class="td_height td_align">6</div></td>
      <td colspan="2">
        <div validate="data_6_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1">
        <div validate="data_6_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">(三)免、抵、退办法出口销售额</div></td>
      <td><div class="td_height td_align">7</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1"><div class="grid-nocontent">---</div></td>
      <td><div class="grid-nocontent">---</div></td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">(四)免税销售额</div></td>
      <td><div class="td_height td_align">8</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1"><div class="grid-nocontent">---</div></td>
      <td><div class="grid-nocontent">---</div></td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height indent_2em">其中：免税货物销售额</div></td>
      <td><div class="td_height td_align">9</div></td>
      <td colspan="2">
        <div validate="data_9_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1"><div class="grid-nocontent">---</div></td>
      <td><div class="grid-nocontent">---</div></td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height indent_4em">&nbsp;免税劳务销售额</div></td>
      <td><div class="td_height td_align">10</div></td>
      <td colspan="2">
        <div validate="data_10_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1"><div class="grid-nocontent">---</div></td>
      <td><div class="grid-nocontent">---</div></td>
    </tr>
    <tr>
      <td rowspan="14">
        <div class="td_align">税<br />款<br />计<br />算</div>
      </td>
      <td colspan="2"><div class="td_height">销项税额</div></td>
      <td><div class="td_height td_align">11</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">进项税额</div></td>
      <td><div class="td_height td_align">12</div></td>
      <td colspan="2">
        <div validate="data_12_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1">
        <div validate="data_12_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">上期留抵税额</div></td>
      <td><div class="td_height td_align">13</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">进项税额转出</div></td>
      <td><div class="td_height td_align">14</div></td>
      <td colspan="2">
        <div validate="data_14_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1">
        <div validate="data_14_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">免、抵、退应退税额</div></td>
      <td><div class="td_height td_align">15</div></td>
      <td colspan="2">
        <div validate="data_15_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1"><div class="grid-nocontent">---</div></td>
      <td><div class="grid-nocontent">---</div></td>
    </tr>
    <tr>
      <td colspan="2"><div style="line-height: 18px">按适用税率计算的纳税检查应补缴税额</div></td>
      <td><div class="td_height td_align">16</div></td>
      <td colspan="2">
        <div validate="data_16_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1"><div class="grid-nocontent">---</div></td>
      <td><div class="grid-nocontent">---</div></td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">应抵扣税额合计</div></td>
      <td><div class="td_align">17=12+13-14-15+16</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td><div class="grid-nocontent">---</div></td>
      <td colspan="1">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td><div class="grid-nocontent">---</div></td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">实际抵扣税额</div></td>
      <td><div class="td_align" style="line-height: 18px">18(如17&lt;11,则为17,否则为11)</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">应纳税额</div></td>
      <td><div class="td_height td_align">19=11-18</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">期末留抵税额</div></td>
      <td><div class="td_height td_align">20=17-18</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td><div class="grid-nocontent">---</div></td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">简易计税办法计算的应纳税额</div></td>
      <td><div class="td_height td_align">21</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="2"><div style="line-height: 18px">按简易计税办法计算的纳税检查应补缴税额</div></td>
      <td><div class="td_height td_align">22</div></td>
      <td colspan="2">
        <div validate="data_22_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1"><div class="grid-nocontent">---</div></td>
      <td><div class="grid-nocontent">---</div></td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">应纳税额减征额</div></td>
      <td><div class="td_height td_align">23</div></td>
      <td colspan="2">
        <div validate="data_23_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1">
        <div validate="data_23_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">应纳税额合计</div></td>
      <td><div class="td_height td_align">24=19+21-23</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td rowspan="14">
        <div class="td_align">税<br />款<br />缴<br />纳</div>
      </td>
      <td colspan="2"><div class="td_height">期初未缴税额（多缴为负数）</div></td>
      <td><div class="td_height td_align">25</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">实收出口开具专用缴款书退税额</div></td>
      <td><div class="td_height td_align">26</div></td>
      <td colspan="2">
        <div validate="data_26_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1"><div class="grid-nocontent">---</div></td>
      <td><div class="grid-nocontent">---</div></td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">本期已缴税额</div></td>
      <td><div class="td_height td_align">27=28+29+30+31</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">①分次预缴税额</div></td>
      <td><div class="td_height td_align">28</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td><div class="grid-nocontent">---</div></td>
      <td colspan="1">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td><div class="grid-nocontent">---</div></td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">②出口开具专用缴款书预缴税额</div></td>
      <td><div class="td_height td_align">29</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td><div class="grid-nocontent">---</div></td>
      <td colspan="1">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td><div class="grid-nocontent">---</div></td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">③本期缴纳上期应纳税额</div></td>
      <td><div class="td_height td_align">30</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">④本期缴纳欠缴税额</div></td>
      <td><div class="td_height td_align">31</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">期末未缴税额（多缴为负数）</div></td>
      <td><div class="td_height td_align">32=24+25+26-27</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">其中：欠缴税额（≥0）</div></td>
      <td><div class="td_height td_align">33=25+26-27</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td><div class="grid-nocontent">---</div></td>
      <td colspan="1">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td><div class="grid-nocontent">---</div></td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">本期应补(退)税额</div></td>
      <td><div class="td_height td_align">34=24-28-29</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td><div class="grid-nocontent">---</div></td>
      <td colspan="1">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td><div class="grid-nocontent">---</div></td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">即征即退实际退税额</div></td>
      <td><div class="td_height td_align">35</div></td>
      <td colspan="2"><div class="grid-nocontent">---</div></td>
      <td><div class="grid-nocontent">---</div></td>
      <td colspan="1">
        <div validate="data_35_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">期初未缴查补税额</div></td>
      <td><div class="td_height td_align">36</div></td>
      <td colspan="2">
        <div validate="data_36_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1"><div class="grid-nocontent">---</div></td>
      <td><div class="grid-nocontent">---</div></td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">本期入库查补税额</div></td>
      <td><div class="td_height td_align">37</div></td>
      <td colspan="2">
        <div validate="data_37_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1"><div class="grid-nocontent">---</div></td>
      <td><div class="grid-nocontent">---</div></td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">期末未缴查补税额</div></td>
      <td><div class="td_height td_align">38=16+22+36-37</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1"><div class="grid-nocontent">---</div></td>
      <td><div class="grid-nocontent">---</div></td>
    </tr>
    <tr>
      <td rowspan="3">
        <div class="td_align">附<br />加<br />税<br />费</div>
      </td>
      <td colspan="2"><div class="td_height">城市维护建设税本期应补（退）税额</div></td>
      <td><div class="td_height td_align">39</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1"><div class="grid-nocontent">---</div></td>
      <td><div class="grid-nocontent">---</div></td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">教育费附加本期应补（退）费额</div></td>
      <td><div class="td_height td_align">40</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1"><div class="grid-nocontent">---</div></td>
      <td><div class="grid-nocontent">---</div></td>
    </tr>
    <tr>
      <td colspan="2"><div class="td_height">地方教育附加本期应补（退）费额</div></td>
      <td><div class="td_height td_align">41</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="1"><div class="grid-nocontent">---</div></td>
      <td><div class="grid-nocontent">---</div></td>
    </tr>
    <tr>
      <td colspan="9">
        <div>
          声明：此表是根据国家税收法律法规及相关规定填写的，本人（单位）对填报内容（及附带资料）的真实性、可靠性、完整性负责。
          <br />
          <p style="text-align: right">纳税人（签章）： 年 月 日</p>
        </div>
      </td>
    </tr>
    <tr>
      <td colspan="4">
        <div>
          经办人：
          <br />
          经办人身份证号：
          <br />
          代理机构签章：
          <br />
          代理机构统一社会信用代码：
        </div>
      </td>
      <td colspan="5">
        <div>
          受理人：
          <br />
          受理税务机关（章）： 国家税务总局北京市
          <br />
          受理日期： 年 月 日
        </div>
      </td>
    </tr>
  </tbody>
</table>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input type="text" autocomplete="off" \/>/g, '<el-input-number v-model.trim="defaultValueNum" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValueNum = ref(0);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
